import { render, staticRenderFns } from "./grid-manager.vue?vue&type=template&id=9ad7c22c"
import script from "./grid-manager.vue?vue&type=script&lang=js"
export * from "./grid-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ad7c22c')) {
      api.createRecord('9ad7c22c', component.options)
    } else {
      api.reload('9ad7c22c', component.options)
    }
    module.hot.accept("./grid-manager.vue?vue&type=template&id=9ad7c22c", function () {
      api.rerender('9ad7c22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/grid-manager.vue"
export default component.exports